import React from "react";
import { Linkedin, Mail, Github } from "lucide-react";
import { Button } from "./ui/button";

function Footer() {
    return (
        <footer className="mt-16 border-t">
            <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-4 px-6 py-8 sm:flex-row">
                <p className="font-mono text-xs text-muted-foreground">
                    © {new Date().getFullYear()} Mauricio Gonzalez <span className="mx-1 text-muted-foreground/50">·</span> exit 0
                </p>
                <div className="flex items-center gap-1">
                    <Button variant="ghost" size="icon" asChild>
                        <a
                            href="https://www.linkedin.com/in/mauric10"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn profile"
                        >
                            <Linkedin />
                        </a>
                    </Button>
                    <Button variant="ghost" size="icon" asChild>
                        <a href="mailto:mauricio@gonzalez-medina.com" aria-label="Send me an email">
                            <Mail />
                        </a>
                    </Button>
                    <Button variant="ghost" size="icon" asChild>
                        <a
                            href="https://github.com/mauriciog88u1"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="GitHub profile"
                        >
                            <Github />
                        </a>
                    </Button>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
